module.exports = __webpack_public_path__ + "img/boost.4c083872.svg";